import React, { /* useState, */ useCallback } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Popconfirm } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faChargingStation,
  // faBatteryThreeQuarters,
  faLock,
  faLockOpen,
  faSignal,
  // faLocationArrow,
  faMapMarker,
  faCarBattery,
  faVolumeUp,
  faUnlockAlt
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  getList,
  actionLock,
  actionUnLock,
  actionOpenBatteryCover,
  actionVoice
} from "actions/scooter/scooter/actions";

import ModalBikeLastPosition from "views/pages/bikes-history/modal-bike-last-position";
import getProgressBar from "views/pages/bikes/helpers/get-progress-bar";
import CommonTable from "views/lib/components/CommonTable";

import Filers from "./filters";

const Scooter = ({
                   list,
                   getList,
                   openCustomModal,
                   closeCustomModal,

                   actionLock,
                   actionUnLock,
                   actionOpenBatteryCover,
                   actionVoice
                 }) => {
  // const [selectedIds, setSelectedIds] = useState({});

/*
  const toggleRow = useCallback((bikeId) => {
    let newSelectedIds = { ...selectedIds };
    if (bikeId) {
      if (newSelectedIds[bikeId]) {
        delete newSelectedIds[bikeId];
      } else {
        newSelectedIds[bikeId] = true;
      }
    } else if (Object.keys(newSelectedIds).length) {
      newSelectedIds = {};
    }

    setSelectedIds(newSelectedIds);
  }, [selectedIds]);
*/

  const handleOpenMap = useCallback((position) => {
    if (!position || !Array.isArray(position)) {
      toast("Coordinates not available", {
        type: toast.TYPE.ERROR,
      });
      return null;
    }
    const modalObj = {
      id: "last-position",
      modalSettings: {
        size: "sm"
      },
      header: "Scooter last position",
      children: (
        <ModalBikeLastPosition
          coordinates={position}
          onCancel={() => closeCustomModal(modalObj)}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCC-gpzzG6hcmAyagvaYCc23KAy4rIkv2A&v=3.exp&libraries=geometry,drawing,places,visualization"
          loadingElement={<div style={{ height: "100%" }}/>}
          containerElement={<div style={{ height: 400 }}/>}
          mapElement={<div style={{ height: "100%" }}/>}
        />
      ),
      handleClose: () => closeCustomModal(modalObj)
    };
    openCustomModal(modalObj);
  }, [openCustomModal, closeCustomModal]);

  /*
  battery: null || string
  batteryLvl: {voltage: 4.19, percent: 81, date: 1658676182340} ?
  date: 1658676182340
  percent: 81
  date: 1658662895174
  gsmSignal: "normal"
  lastBookDate: 0
  located: {longitude: 44.48914, latitude: 40.137193333333336, timestamp: 1658676058827}
  latitude: 40.137193333333336
  longitude: 44.48914
  timestamp: 1658676058827
  mileage: {mileage: 0, remainingMileage: 33040, speed: 0}
  mileage: 0
  remainingMileage: 33040
  state: "ON"
  type: "NINEBOT_ZK601"
  *  */
  const getColumns = () => [
    /* {
      id: "checkbox",
      accessor: "",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <input
          type="checkbox"
          className="checkbox"
          checked={!!selectedIds[original.id]}
          onChange={() => toggleRow(original.id)}
        />
      ),
      Header: "",
      sortable: false,
      filterable: false,
      resizable: false,
      minResizeWidth: 50,
      width: 50,
    }, */
    {
      id: "qr",
      Header: "QR",
      accessor: "qr",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/scooter/scooter/${original.id}`}>
          {original.qr}
        </Link>
      )
    },
    {
      id: "Status",
      Header: "Status",
      accessor: "status"
    },
    {
      id: "speed",
      Header: "Speed",
      // eslint-disable-next-line react/display-name
      accessor: original => (
        <div className={original.mileage.speed ? "text-success" : "text-muted"}>
          {original.mileage.speed} km/h
        </div>
      ),
    },
    {
      id: "mileage",
      Header: "Mileage",
      // eslint-disable-next-line react/display-name
      accessor: original => (
        <div className={original.mileage.mileage ? "text-success" : "text-muted"}>
          {original.mileage.mileage || 0}
        </div>
      ),
    },
    {
      id: "lastRideUser",
      Header: "Last Ride",
      accessor: "lastRideUser",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.lastRideUser) {
          return (
            <Link to={`/users/${original.lastRideUser}`}>
              {original.lastRideUser}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "voltage",
      Header: "Voltage",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => original.voltage,
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div>
          {getProgressBar(original.batteryLvl, `(${original.batteryLvl.percent}%)`)}
        </div>
      )
    },
    {
      id: "battery",
      Header: "Battery ID",
      className: "text-center",
      headerClassName: "text-center",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (original.battery || "")
    },
    {
      id: "charging",
      Header: "Charging",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => original.charging,
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div>
          {original.charging ? "Yes" : "No"}
        </div>
      )
    },
    {
      id: "online",
      Header: "Online",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => original.connected.online,
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div>
          <FontAwesomeIcon
            icon={faSignal}
            className={original.connected.online ? "text-success" : "text-danger"}
          />
        </div>
      )
    },
    {
      id: "sim",
      Header: "Sim",
      accessor: original => original.sim,
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div>
          <div>{original.sim && original.sim.phone ? original.sim.phone : "No Phone"}</div>
          <small
            className="text-muted">{original.sim && original.sim.serial ? original.sim.serial : "No Serial"}</small>
        </div>
      ),
    },
    {
      id: "locked",
      Header: "Locked",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => original.locked,
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <div>
          <FontAwesomeIcon
            icon={original.locked
              ? faLock
              : faLockOpen}
            className={original.locked ? "text-success" : "text-danger"}
          />
        </div>
      )
    },
    {
      id: "on-map",
      Header: "Map",
      className: "text-center",
      headerClassName: "text-center",
      accessor: original => original.position,
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleOpenMap([original.located.longitude, original.located.latitude])}
          title="Last position"
        >
          <FontAwesomeIcon icon={faMapMarker}/>
        </button>
      )
    },
    {
      id: "actions",
      Header: "Actions",
      className: "text-center",
      headerClassName: "text-center",
      width: 150,
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <React.Fragment>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => (original.locked
                ? actionUnLock(original.id)
                : actionLock(original.id)
            )}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            {original.locked ? (
              <button className="btn btn-sm btn-warning" title="Unlock">
                <FontAwesomeIcon icon={faUnlockAlt}/>
              </button>
            ) : (
              <button className="btn btn-sm btn-warning" title="Lock">
                <FontAwesomeIcon icon={faLock}/>
              </button>
            )}
          </Popconfirm>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => actionOpenBatteryCover(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-danger ml-2" title="Open battery cover">
              <FontAwesomeIcon icon={faCarBattery}/>
            </button>
          </Popconfirm>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => actionVoice(original.id)}
            placement="bottomRight"
            okText="Yes"
            cancelText="Cancel"
          >
            <button className="btn btn-sm btn-info ml-2" title="Voice">
              <FontAwesomeIcon icon={faVolumeUp}/>
            </button>
          </Popconfirm>
        </React.Fragment>
      )
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={getList}
      FiltersComponent={Filers}
      searchHookProps={{
        size: 20,
        sort: "id,asc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.scooter.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
  actionLock: bindActionCreators(actionLock, dispatch),
  actionUnLock: bindActionCreators(actionUnLock, dispatch),
  actionOpenBatteryCover: bindActionCreators(actionOpenBatteryCover, dispatch),
  actionVoice: bindActionCreators(actionVoice, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(Scooter);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/scooter/index.js